<div class="grid grid-cols-2 space-x-6">
	<div class="flex flex-col gap-5">
		<ui-section title="General Details">
			<div section-content class="space-y-4">
				<ui-info-row infoLabel="Instructions Source">
					<app-dropdown
						label=""
						[itemGroups]="[{ items: instructionSourceOptions }]"
						[ngModel]="selectedInstructionSourceText"
						(onSelect)="setSource($event)"
						class="flex-1"
					></app-dropdown>
				</ui-info-row>
				<ui-info-row infoLabel="Charge Type">
					<app-charge-type-dropdown
						[mortgage]="_mortgage"
					></app-charge-type-dropdown>
				</ui-info-row>
				<ui-info-row infoLabel="Loan Reference #">
					<app-input
						class="flex-1"
						label=""
						[ngModel]="_mortgage?.referenceNumber"
						(debounce)="setReferenceNumber($event)"
					></app-input>
				</ui-info-row>
				<ui-info-row infoLabel="Standard Charge Term #">
					<app-input
						class="flex-1"
						label=""
						[ngModel]="_mortgage?.standardChargeTerm"
						(debounce)="setStandardChargeTerm($event)"
					></app-input>
				</ui-info-row>
				<ui-info-row infoLabel="Deal ID">
					<app-input
						class="flex-1"
						label=""
						[ngModel]="_mortgage?.dealId"
						(debounce)="setDealId($event)"
					></app-input>
				</ui-info-row>
				<ui-info-row infoLabel="Closing Date">
					<app-sale-closing-date
						class="flex-1"
						label=""
						orientation="col"
					></app-sale-closing-date>
				</ui-info-row>
				<ui-info-row infoLabel="Commitment Date">
					<app-date-picker
						class="flex-1"
						label=""
						[ngModel]="_mortgage?.commitmentDate"
						(ngModelChange)="setCommitmentDate($event)"
					></app-date-picker>
				</ui-info-row>
				<ui-info-row infoLabel="Lender Comments">
					<app-text-area
						class="flex-1"
						label=""
						[ngModel]="_mortgage?.remarks"
						(debounce)="setRemarks($event)"
					/>
				</ui-info-row>
				<ui-info-row
					infoLabel="Priority"
					*ngIf="_mortgage?.transactionType !== TransactionType.BRIDGE"
				>
					<div
						class="space-x-2 flex flex-row items-center justify-between align-middle max-w-48"
					>
						<span class="text-gray-500">{{
							(_mortgage?.priority
								? (_mortgage?.priority | ordinalSuffix)
								: '') + ' Priority'
						}}</span>
						<ui-button
							actions
							(click)="editPriority()"
							icon="edit"
							preset="ICON_DEFAULT"
							size="sm"
						></ui-button>
					</div>
				</ui-info-row>
			</div>
		</ui-section>
		<app-manual-mortgage-lender-details
			[mortgage]="_mortgage"
			(onLenderRemoved)="onLenderRemoved($event)"
			(onLenderUpdated)="onLenderUpdated($event)"
			(onLenderAdded)="onLenderAdded($event)"
			(onLenderAssociationAdded)="onAddAssociation($event)"
			(onRemoveLenderInvestor)="onRemoveInvestor($event)"
			(onLenderSetAsPrimary)="onLenderSetAsPrimary($event)"
			(onCorrespondenceSolicitorUpdate)="onSolicitorUpdated($event)"
			(onCorrespondenceRemove)="onCorrespondenceRemoved()"
			(onPercentageOfInterestTypeUpdated)="
				onPercentageOfInterestTypeUpdated($event)
			"
			(onLenderPercentageOfInterestDetailsUpdated)="
				onLenderPercentageOfInterestUpdated($event)
			"
		></app-manual-mortgage-lender-details>
	</div>
	<div class="flex flex-col gap-5">
		<app-mortgage-uploaded-documents
			[mortgage]="_mortgage"
		></app-mortgage-uploaded-documents>
		<ui-section
			title="Funding Details"
			data-intercom-target="manual-funding-details"
			*ngIf="_mortgage?.chargeType"
		>
			<div section-content>
				<app-closer-sync-funding-details></app-closer-sync-funding-details>
			</div>
		</ui-section>

		<app-mortgage-broker [mortgage]="_mortgage"></app-mortgage-broker>

		<app-mortgage-guarantors
			[matterMortgageId]="_mortgage?.id"
		></app-mortgage-guarantors>
	</div>
</div>
